import {basicInfo} from "../../data/EditChapterPart/BasicInfo";
// import * as net from "../../utils/network";
import api from '../../utils/api';
import {loadBlankVideo, addSlimLecture, updateSlimLecture} from './videoActions';
import {NotificationManager} from 'react-notifications';

export const ACTION_GET_CHAPTER_PART_INFO = 'ACTION_GET_CHAPTER_PART_INFO';
export const ACTION_UPDATE_CHAPTER_PART_INFO = 'ACTION_UPDATE_CHAPTER_PART_INFO';
export const ACTION_GOT_NEW_VIDEO = 'ACTION_GOT_NEW_VIDEO';
export const ACTION_LOAD_BLANK = 'ACTION_LOAD_BLANK';

export const ACTION_ADDED_CHAPTER_PART = 'ACTION_ADDED_CHAPTER_PART';
export const ACTION_IMAGE_ADDED = 'ACTION_IMAGE_ADDED';
export const ACTION_VIDEO_QUESTION_ADDED = 'ACTION_VIDEO_QUESTION_ADDED';
export const ACTION_QUIZ_QUESTION_ADDED = 'ACTION_QUIZ_QUESTION_ADDED';
export const ACTION_QUIZ_QUESTION_DELETED = 'ACTION_QUIZ_QUESTION_DELETED';
export const ACTION_VIDEO_QUESTION_DELETED = 'ACTION_VIDEO_QUESTION_DELETED';
export const ACTION_QUIZ_QUESTION_UPDATED = 'ACTION_QUIZ_QUESTION_UPDATED';
export const ACTION_VIDEO_QUESTION_UPDATED = 'ACTION_VIDEO_QUESTION_UPDATED';

// Chapter Tests
export const CHAPTER_TEST_RETRIEVED = 'CHAPTER_TEST_RETRIEVED';
export const CHAPTER_TEST_TEMPLATE_RETRIEVED = 'CHAPTER_TEST_TEMPLATE_RETRIEVED';
export const CHAPTER_TEST_TEMPLATES_RETRIEVED = 'CHAPTER_TEST_TEMPLATES_RETRIEVED';
export const CHAPTER_TEST_SAVED = 'CHAPTER_TEST_SAVED';
export const UPLOADED_FILE = 'UPLOADED_FILE';
export const UPLOADED_SECTION_FILE = 'UPLOADED_SECTION_FILE';
export const TEST_UPDATED = 'TEST_UPDATED';
export const ADD_TEST_QUESTION = 'ADD_TEST_QUESTION';
export const ADD_TEST_SECTION = 'ADD_TEST_SECTION';
export const TEST_SECTION_UPDATED = 'TEST_SECTION_UPDATED';
export const TEST_QUESTION_UPDATED = 'TEST_QUESTION_UPDATED';
export const TEST_DELETE_QUESTION = 'TEST_DELETE_QUESTION';
export const RESET_TEST_TEMPLATE = 'RESET_TEST_TEMPLATE';
export const ACTION_BANNER_ADDED = 'ACTION_BANNER_ADDED';
export const VIDEO_UPLOADED = 'VIDEO_UPLOADED';
export const VIDEO_DELETED = 'VIDEO_DELETED';

// function actionChapterPartInfoLoaded(notifications) {
//     return {
//         type: ACTION_GET_CHAPTER_PART_INFO,
//         payload: basicInfo
//     };
// }
//
// CREATORS
// export function getChapterPartInfo() {
//     return (dispatch, getState) => {
//         const {core} = getState();
//
//         net.aGet('')
//             .then(data => {
//                 dispatch(actionChapterPartInfoLoaded(data.filter((student) => student.course === core.user.course))); //or any other relevant condition
//             });
//     };
// }

export function getChapterPartInfo() {
    return {
        type: ACTION_GET_CHAPTER_PART_INFO,
        payload: basicInfo
    };
}

function emitLoadBlank(){
    return {
        type: ACTION_LOAD_BLANK,
        payload: {}
    }
}

function emitImageAdded(image){
    return {
        type: ACTION_IMAGE_ADDED,
        payload: image
    }
}

function emitBannerAdded(image){
    return {
        type: ACTION_BANNER_ADDED,
        payload: image
    }
}

export function deleteCourseTest(id){
    return {
        type: 'DELETED_COURSE_TEST',
        payload: id
    }
}

export function loadBlanks(){
    return (dispatch) => {
        dispatch(emitLoadBlank());
        dispatch(loadBlankVideo());
    }
}



export function getChapterPartInfoFromObject(part) {
    return {
        type: ACTION_GET_CHAPTER_PART_INFO,
        payload: part
    };
}

export function updateChapterPartInfo(info) {
    return {
        type: ACTION_UPDATE_CHAPTER_PART_INFO,
        payload: info
    };
}

export function addChapterPartInfo(part){
    return {
        type: ACTION_ADDED_CHAPTER_PART,
        payload: part
    }
}

function addedVideoQuestion(question){
    return {
        type: ACTION_VIDEO_QUESTION_ADDED,
        payload: question
    }
}

function addedQuizQuestion(question){
    return {
        type: ACTION_QUIZ_QUESTION_ADDED,
        payload: question
    }
}

function updatedQuizQuestion(question){
    return {
        type: ACTION_QUIZ_QUESTION_UPDATED,
        payload: question
    }
}

function deletedQuizQuestion(id){
    return {
        type: ACTION_QUIZ_QUESTION_DELETED,
        payload: id
    }
}

function deletedVideoQuestion(id){
    return {
        type: ACTION_VIDEO_QUESTION_DELETED,
        payload: id
    }
}

export function attachVideoToChapterPart(video){
    return {
        type: ACTION_GOT_NEW_VIDEO,
        payload: video
    }
}

function updatedVideoQuestion(question){
    return {
        type: ACTION_VIDEO_QUESTION_UPDATED,
        payload: question
    }
}


// Chapter test callbacks
function retrievedChapterTest(test){
    return {
        type: CHAPTER_TEST_RETRIEVED,
        payload: test
    }
}

function retrievedChapterTestTemplate(test){
    return {
        type: CHAPTER_TEST_TEMPLATE_RETRIEVED,
        payload: test
    }
}


export function loadChapterTest(testId, token){
    return dispatch => {
        api.getChapterTest(testId, token, res => {
            dispatch(retrievedChapterTest(res.data));
        })
    }
}

export function loadDiagnosticTest(testId, token){
    return dispatch => {
        api.getDiagnosticTest(testId, token, res => {
            dispatch(retrievedChapterTest((res.data)));
        })
    }
}

// Chapter part functions

export function addChapterPart(info, chapterId, token){
    return (dispatch) => {
        api.addChapterVideo(info, chapterId, token, res => {
            if(res.status === 200){
                NotificationManager.success("Lecture has been saved.  Remember to mark the lecture as active", "Saved");
                dispatch(loadBlankVideo());
                dispatch(addSlimLecture(res.data));
                dispatch(addChapterPartInfo(res.data));
            }
        })
    }
}

export function uploadChapterPartImage(data, chapterPartId, token){
    return (dispatch) => {
        api.uploadChapterPartImage(data, chapterPartId, token, res => {
           if(res.status === 200){
                dispatch(emitImageAdded(res.data));
           }
        });
    }
}

export function uploadChapterPartBanner(data, chapterPartId, token){
    return (dispatch) => {
        api.uploadChapterPartBanner(data, chapterPartId, token, res => {
           if(res.status === 200){
                dispatch(emitBannerAdded(res.data));
           }
        });
    }
}

export function getChapterPartById(id, token){
    return (dispatch) => {
        api.getChapterVideo(id, token, res => {
            if(res.status === 200){
                dispatch(getChapterPartInfoFromObject(res.data));
            }
        })
    }
}

export function updateChapterPartVideo(video, chapterPartId, token){
    return (dispatch) => {
        api.deleteChapterPartVideoFile(chapterPartId, token, res => {
            if(res.status === 200 || res.status === 204){
                api.updateChapterPartIdOfVideo(video, chapterPartId, token, res => {
                    if(res.status === 200){
                        dispatch(getChapterPartById(chapterPartId, token));
                    }
                })
            }
        })
    }
}

export function addChapterPartVideo(video, chapterPartId, token){
    return (dispatch) => {
                api.addChapterPartIdOfVideo(video, chapterPartId, token, res => {
                    if(res.status === 200){
                        dispatch(getChapterPartById(chapterPartId, token));
                    }
                })
    }
}

export function updateChapterPart(part, id, token){
    return (dispatch) => {
        api.updateChapterPart(part, id, token, res => {
            if(res.status === 200){
                NotificationManager.success("Lecture has been saved.  Remember to mark the lecture as active.", "Saved");
                dispatch(getChapterPartById(id, token));
                dispatch(updateSlimLecture(res.data));
            }
        })
    }
}

export function addVideoQuestion(question, id, token){
    return (dispatch) => {
        api.addVideoQuestion(question, id, token, res => {
            if(res.status === 200){
                dispatch(addedVideoQuestion(res.data));
            }
        })
    }
}

export function addQuizQuestion(question, files, id, token){
    return (dispatch) => {
        api.addQuizQuestion(question, id, token, res => {
            if(res.status === 200){

                if(res.data.id){
                    files.map(f => {
                        api.uploadQuestionFile(f, res.data.id, token, r => {
                        });
                    })
                }

                api.getQuizQuestion(res.data.id, token, q => {
                    dispatch(addedQuizQuestion(q.data));
                })

            }
        })
    }
}

export function deleteQuizQuestion(id, token){
    return (dispatch) => {
        api.deleteQuizQuestion(id, token, res => {
            if(res.status === 200){
                dispatch(deletedQuizQuestion(id));
            }
        })
    }
}

export function deleteQuestionFile(id, token){
    return dispatch => {
        api.deleteQuestionFile(id, token, res => {
        })
    }
}

export function updateQuizQuestion(id, question, files, token){
    return (dispatch) => {
        api.updateQuizQuestion(id, question, token, res => {
            if(res.status === 200){

                if(id && files.length > 0){
                    files.map((f, c) => {
                        api.uploadQuestionFile(f, id, token, r => {
                            if(c == files.length - 1){
                                api.getQuizQuestion(res.data.id, token, q => {
                                    dispatch(updatedQuizQuestion(q.data));
                                })
                            }
                        });
                    })
                }else{
                    api.getQuizQuestion(res.data.id, token, q => {
                        dispatch(updatedQuizQuestion(q.data));
                    })
                }



            }
        })
    }
}

export function editVideoQuestion(question, token){
    return (dispatch) => {
        api.updateVideoQuestion(question, token, res => {
            dispatch(updatedVideoQuestion(res.data));
        })
    }
}

export function deleteVideoQuestion(id, token){
    return (dispatch) => {
        api.deleteVideoQuestion(id, token, res => {
            if(res.status === 200){
                dispatch(deletedVideoQuestion(id));
            }
        })
    }
}

export function getChapterTest(id, token){
    return (dispatch) => {
        api.getChapterTest(id, token, res => {
            dispatch(retrievedChapterTest(res.data));
        })
    }
}

// Chapter test functions
export function updateChapterTest(test, token){
    return (dispatch) => {
        NotificationManager.success('Saved test.');
        if(test.id){
            api.updateChapterTest(test, token, res => {
                dispatch(retrievedChapterTest(res.data));
            });
        }else{
            api.addChapterTest(test, token, res => {
                dispatch(retrievedChapterTest(res.data));
            })
        }
    }
}


function uploadedFile(res, type){
    if(type.f === 'section'){
        return {
            type: UPLOADED_SECTION_FILE,
            payload: {image: res.data, questionData: type}
        }
    }else{
        return {
            type: UPLOADED_FILE,
            payload: {image: res.data, questionData: type}
        }
    }
}

export function uploadFile(data, profileId, type, token){
    return dispatch => {

        api.uploadTestFile(data, profileId, token, res => {
            dispatch(uploadedFile(res, type));
        })
        
        
    }
}

export function updateTest(test){
    return {
        type: TEST_UPDATED,
        payload: test
    }
}

export function addTestQuestion(partial, section){
    return {
        type: ADD_TEST_QUESTION,
        payload: {partial, section}
    }
}

export function addTestQuestionWithData(q, section){
    return {
        type: 'ADD_TEST_QUESTION_WITH_DATA',
        payload: {q, section}
    }
}

export function addTestSection(){
    return {
        type: ADD_TEST_SECTION,
        payload: {}
    }
}

export function updateSectionField(index, field, value){
    return {
        type: TEST_SECTION_UPDATED,
        payload: {index, field, value}
    }
}

export function updateTestQuestion(sectionIndex, index, field, value){
    return {
        type: TEST_QUESTION_UPDATED,
        payload: {sectionIndex, index, field, value}
    }
}

export function deleteTestQuestion(params){
    return {
        type: TEST_DELETE_QUESTION,
        payload: params
    }
}

export function deleteSubSection(params){
    return {
        type: 'TEST_DELETE_SUBSECTION',
        payload: params
    }
}

export function deleteSection(params){
    return {
        type: 'TEST_DELETE_SECTION',
        payload: params
    }
}

function retrievedChapterTestTemplate(test, mode){
    // console.log("Savedand", mode);
    return {
        type: CHAPTER_TEST_TEMPLATE_RETRIEVED,
        payload: {test: test, mode}
    }
}

export function updateChapterTestTemplate(test, token){
    return (dispatch) => {
        // console.log("test id?", test.id);
        NotificationManager.success('Saved test.');
        if(test.id){
            api.updateChapterTestTemplate(test, token, res => {
                dispatch(retrievedChapterTestTemplate(res.data, 'updated'));
            });
        }else{
            api.addChapterTestTemplate(test, token, res => {
                dispatch(retrievedChapterTestTemplate(res.data, 'added'));
            })
        }
    }
}

function chapterTestTemplatesRetrieved(tests){
    return {
        type: CHAPTER_TEST_TEMPLATES_RETRIEVED,
        payload: tests
    }
}

export function getChapterTestTemplates(token){
    return dispatch => {
        api.getChapterTestTemplates(token, res => {
            dispatch(chapterTestTemplatesRetrieved(res.data));
        })
    }
}

export function getDiagTemplates(token){
    return dispatch => {
        api.getDiagTemplates(token, res => {
            dispatch({
                type: 'GOT_DIAG_TEMPLATES',
                payload: res.data
            })
        })
    }
}

export function addToDiagnosticTests(data){
    return dispatch => {
        dispatch({
            type: 'ADD_DIAG_TEST',
            payload: data
        })
    }
}

export function resetTestTemplate(){
    return {
        type: RESET_TEST_TEMPLATE,
        payload: ''
    }
}

export function videoUploaded(video){
    return {
        type: VIDEO_UPLOADED,
        payload: video
    }
}

export function videoDeleted(){
    return {
        type: VIDEO_DELETED
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/chapterPartActions.js